
    import Component from "vue-class-component";
    import Vue from "vue";
    import { Prop } from "vue-property-decorator";
    import { BModal } from "bootstrap-vue";
    import {
        EndorsementsClient, ResultError,
        SuspensionReason,
        SuspensionReasonModel,
    } from "../../../api-client";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";

    class SuspensionOption {
        constructor(public value: SuspensionReason, public text: string) {}
    }

    @Component({
        components: {
            LabelOptional,
        },
    })
    export default class SuspensionModal extends Vue {
        @Prop({ required: true })
        title!: string;

        @Prop({ required: true })
        actionButtonText!: string;

        @Prop({ required: true })
        confirm!: (
            comment: string,
            reason: SuspensionReason,
            startedOn: Date,
            validUntil: Date | null
        ) => Promise<undefined>;

        suspensionReasonModels: SuspensionReasonModel[] = [];
        selectedReason: SuspensionReason | null = null;
        comment = "";
        startedOn: Date = new Date();
        validUntil: Date | null = null;
        validationError: ResultError | null = null;

        $refs!: { bmodal: BModal };

        cancel() {
            this.$refs.bmodal.hide();
            this.comment = "";
            this.selectedReason = null;
        }

        public async created() {
            await this.getSuspensionReasonOptionsIfNecessary();
        }

        async confirmInner() {
            this.validationError = null;
            await this.confirm(
                this.comment,
                this.selectedReason!,
                this.startedOn,
                this.validUntil
            ).then(() => this.$refs.bmodal.hide(), errorResponse => this.validationError = errorResponse);
        }

        public async show() {
            this.$refs.bmodal.show();
        }

        async getSuspensionReasonOptionsIfNecessary() {
            if (this.suspensionReasonModels.length === 0) {
                (
                    await new EndorsementsClient().suspensionReasons()
                ).forEach((x) => this.suspensionReasonModels.push(x));
                this.selectedReason = this.suspensionReasonModels[0].code; // .. because we have only one option
            }
        }

        get suspensionReasonOptions() {
            return this.suspensionReasonModels.map(
                (x) => new SuspensionOption(x.code, x.description)
            );
        }

        get isButtonDisabled(): boolean {
            return this.selectedReason === null || this.startedOn === null;
        }
    }
